<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="유통데이터 활용 경진대회 소개" src="/images/sub/sub-visual-circulation.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <template v-if="festa">
            <!-- S: 행사 소개 -->
            <page-section title="행사소개" class="page-section--first">
                <div class="tit-wrap pb-0">
                    <h3 class="tit tit--xl" data-aos="fade-right" data-aos-delay="100">
                        <div v-html="festa.section2.txt[0]?.replace(/\n/g, '<br/>')" />
                    </h3>
                    <div class="txt txt--lg txt--dark" data-aos="fade-right" data-aos-delay="200">
                        <div v-html="festa.section2.txt[1]?.replace(/\n/g, '<br/>')" />
                    </div>
                </div>
                <div class="page-section__bg" style="background-image:url(/images/common/grey-bg.png);"></div>
            </page-section>
            <!-- E: 행사 소개 -->

            <!-- S: 데이터를 활용한 새로운 전략 제시 -->
            <page-section
            title="데이터를 활용한 새로운 전략 제시"
            :text="festa?.section1?.txt"
            class="pb-0">
                <v-img src="/images/sub/circulation/circulation-img.jpg" :aspect-ratio="1200 / 632" max-width="1200" contain class="d-none d-md-block"  data-aos="fade-up" data-aos-delay="100"/>
                <v-img src="/images/sub/circulation/circulation-img-mo.jpg" max-width="672" contain class="d-md-none mx-auto"  data-aos="fade-up" data-aos-delay="100"/>
            </page-section>
            <!-- E: 데이터를 활용한 새로운 전략 제시 -->

            <!-- S: 행사 개요 -->
            <page-section title="행사개요" class="pb-0">
                <table-primary>
                    <table-primary-row v-for="(item, index) in festa.section3.table.list" :key="index">
                        <template #title>
                            <span v-html="item.title.replace(/\n/g, '<br />')" />
                        </template>
                        <template #text>
                            <p v-html="item.input.replace(/\n/g, '<br />')" />
                        </template>
                    </table-primary-row>
                </table-primary>
            </page-section>
            <!-- E: 행사 개요 -->

            <!-- S: 프로세스 -->
            <page-section title="프로세스" class="pb-0">
                <v-img src="/images/sub/circulation/circulation-img2.jpg" :aspect-ratio="1200 / 368" max-width="1200" contain class="d-none d-md-block"  data-aos="fade-up" data-aos-delay="100"/>
                <v-img src="/images/sub/circulation/circulation-img2-mo.jpg" max-width="672" contain class="d-md-none mx-auto"  data-aos="fade-up" data-aos-delay="100"/>
            </page-section>
            <!-- E: 프로세스 -->

            <!-- S: 경진대회 주요 자료 -->
            <page-section
            title="경진대회 주요 자료"
            :text="festa?.section4?.txt"
            class="page-section--last">
                <div class="tab-wrap" data-aos="fade-right" data-aos-delay="100">
                    <u-tabs>
                        <u-tab v-for="(category, index) in categories" :key="index" @click="(filter.category = category), search(true)">
                            {{ category }}
                        </u-tab>
                    </u-tabs>
                </div>

                <v-divider class="grey darken-4 mb-20px mb-md-32px" style="border-width: 2px 0 0;" />
                <v-row data-aos="fade-up" data-aos-delay="200">
                    <v-col v-for="data in datas" :key="data._id" cols="6" md="4">
                        <card-board :to="`/circulation/data/${data._id}`" :chip="data?.awardName" :title="data?.subject" :teamName="data?.name" :view="String(data?.viewCount)"> </card-board>
                    </v-col>
                </v-row>
                <v-layout justify-center class="mt--md">
                    <v-btn to="/circulation/data" color="grey" dark class="v-btn--width-fixed justify-space-between">더 보기 <v-icon class="font-size-18">mdi-plus</v-icon></v-btn>
                </v-layout>
            </page-section>
            <!-- E: 경진대회 주요 자료 -->
        </template>
    </client-page>
</template>

<script>
import api from "@/api";

import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/components/dumb/page-section.vue";
import TablePrimary from "@/components/dumb/table-primary.vue";
import TablePrimaryRow from "@/components/dumb/table-primary-row.vue";
import UTabs from "@/components/dumb/u-tabs.vue";
import UTab from "@/components/dumb/u-tab.vue";
import CardBoard from "@/components/dumb/card-board.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TablePrimary,
        TablePrimaryRow,
        UTabs,
        UTab,
        CardBoard
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data() {
        return {
            festa: null,
            filter: {
                category: null,
            },
            datas: [],

            categories: [ "전체" ],
            limit: 6,

            categoriesYoutube,
            categoriesReport,
            categoriesForms,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { festa } = await api.v1.circulation.festa.get();
            this.festa = festa;
            let { setting } = await api.v1.setting.get();
            this.categories.push(...setting.datas.categories);
            await this.search();
        },
        async search() {


            let { summary, datas } = await api.v1.circulation.datas.gets({
                headers: {
                    limit: this.limit,
                },
                params: this.filter,
            });
            this.datas = datas;
        },
    },
};
</script>
